import { memo, useEffect } from 'react';

import eventEmitter, { GameEvents } from '../../../pages/Home/eventEmiter';
import { slotFileList } from '../../../PIXIHelpers/pixiConstants';
import { SlotMachinePixiApp } from '../../../apps/slotMachine';

function SlotMachinePixi() {
  useEffect(() => {
    const slot = document.getElementById('slot-test');
    let slotGame = SlotMachinePixiApp.getInstance();

    if (!slotGame.getApp()) {
      SlotMachinePixiApp.resetInstance();
      slotGame = SlotMachinePixiApp.getInstance();
    }
    if (slotGame.getApp().view) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      slot?.appendChild(slotGame?.getApp()?.view);
      slotGame.getApp().resize();
      slotGame.intialRenderAnimations(slotFileList);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const handler = (data) => {
      if (data?.targetSlots) {
        slotGame.startSpin(data.targetSlots);
      }
    };

    const hideMiddle = () => {
      slotGame.hideMiddle();
    };

    const showMiddle = () => {
      slotGame.showMiddle();
    };

    eventEmitter.on(GameEvents.SLOT_START_SPIN, handler);
    eventEmitter.on(GameEvents.SLOT_HIDE_MIDDLE, hideMiddle);
    eventEmitter.on(GameEvents.SLOT_SHOW_MIDDLE, showMiddle);

    return () => {
      eventEmitter.off(GameEvents.SLOT_START_SPIN, handler);
      eventEmitter.off(GameEvents.SLOT_HIDE_MIDDLE, hideMiddle);
      eventEmitter.off(GameEvents.SLOT_SHOW_MIDDLE, showMiddle);

      slotGame.destroy();
      SlotMachinePixiApp.resetInstance();
    };
  }, []);
  return (
    <div id="slot-test" />
  );
}

export default memo(SlotMachinePixi);
